/* Maison Poster — scripts */
(function () {
  'use strict';

  // Menu mobile
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('[data-header]');
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Quantité +/−
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Livraison estimée : « entre le jeu. 9 oct. et le mer. 15 oct. » (jours ouvrables)
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  document.querySelectorAll('[data-eta]').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 5, max = Math.max(min, parseInt(el.dataset.max, 10) || 10);
    var fmt = new Intl.DateTimeFormat('fr-CH', { weekday: 'short', day: 'numeric', month: 'long' });
    var now = new Date();
    var txt = el.querySelector('[data-eta-text]');
    if (!txt) return;
    txt.innerHTML = 'Commandez aujourd’hui, reçu <strong>entre le ' + fmt.format(addBusinessDays(now, min)) + ' et le ' + fmt.format(addBusinessDays(now, max)) + '</strong>';
    el.hidden = false;
  });

  // Barre d'achat collante (mobile) : visible quand le bouton principal n'est plus à l'écran
  document.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
    var section = bar.closest('[data-product-section]');
    var mainBtn = section && section.querySelector('[data-add-button]');
    var form = mainBtn && mainBtn.form;
    var btn = bar.querySelector('[data-sticky-add]');
    if (!mainBtn || !form || !btn || !('IntersectionObserver' in window)) return;
    var mainVisible = true, pastTop = false;
    function render() {
      var show = !mainVisible && pastTop;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting; render(); }).observe(mainBtn);
    window.addEventListener('scroll', function () {
      var p = window.scrollY > 300;
      if (p !== pastTop) { pastTop = p; render(); }
    }, { passive: true });
    btn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      // passe par le même chemin que le bouton principal (validation + fichier HD)
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
  });

  // Fiche produit
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var mainImg = section.querySelector('.product__main-image img');
    var thumbs = section.querySelectorAll('[data-thumb]');

    function showImage(src, mediaId) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(t.dataset.mediaId) === String(mediaId) ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.dataset.thumb, t.dataset.mediaId); });
    });

    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return;
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceEl = section.querySelector('[data-price]');
    var labels = { add: addLabel ? addLabel.textContent.trim() : 'Ajouter au panier' };
    var moneyFormat = new Intl.NumberFormat('fr-CH', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF' });

    function selectedOptions() {
      var values = [];
      picker.querySelectorAll('fieldset').forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        values[i] = checked ? checked.value : null;
      });
      return values;
    }

    function update() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Indisponible';
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? labels.add : 'Épuisé';
      var stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = moneyFormat.format(variant.price / 100);
      var stickyBtn = section.querySelector('[data-sticky-add]');
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (priceEl) {
        var html = moneyFormat.format(variant.price / 100);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s>' + moneyFormat.format(variant.compare_at_price / 100) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
        showImage(src, variant.featured_media ? variant.featured_media.id : null);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', update);
  });
})();
